module.exports = __webpack_public_path__ + "static/media/BGR.d3325a1e.svg";